<script lang="ts">
  import type { Toast } from "../core/types";

  interface Props {
    toast: Toast;
  }

  let { toast }: Props = $props();
</script>

<div class="toaster-message" {...toast.ariaProps}>
  {#if typeof toast.message === "string"}
    {@html toast.message}
  {:else}
    {@const Message = toast.message}
    <Message {toast} {...toast.props} />
  {/if}
</div>

<style>
  .toaster-message {
    display: flex;
    margin: 0px 0 0 12px;
    color: inherit;
    flex: 1 1 auto;
    white-space: pre-line;
    font-size: 16px;
    color: var(--default);
    align-items: center;
    min-width: 0px;
  }
</style>
